import cn from 'classnames';
import { ReactNode } from 'react';

import '@/components/common/Button/Button.style.scss';
import LoadingSpinner from '@/components/common/LoadingSpinner/LoadingSpinner';

type SubmitButtonProps = {
  className?: string;
  children: ReactNode;
  variant?: 'dark' | 'light' | 'transparent';
  size?: 'large' | 'small';
  disabled?: boolean;
  isLoading?: boolean;
};

function SubmitButton(props: SubmitButtonProps) {
  const {
    className = '',
    variant = 'dark',
    children,
    size = 'large',
    disabled = false,
    isLoading = false
  } = props;

  return (
    <button
      className={cn(
        'Button',
        'SubmitButton',
        variant,
        size,
        { disabled },
        className
      )}
      type='submit'
      disabled={disabled || isLoading}
    >
      {isLoading ? <LoadingSpinner size={10} /> : children}
    </button>
  );
}

export default SubmitButton;
